import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedshift = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.272 76.459l38.027 9.054V14.285l-38.028 9.054v53.12z",
			fill: "#205B97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.299 14.285l7.243 3.622v63.985l-7.243 3.621V14.285zM50.27 76.459l-38.028 9.054V14.285l38.028 9.054v53.12z",
			fill: "#5193CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.243 14.285L5 17.907v63.985l7.243 3.621V14.285z",
			fill: "#205B97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.93 100l14.488-7.243V7.243L59.93 0l-4.429 47.486L59.931 100z",
			fill: "#5193CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.612 100l-14.487-7.243V7.243L40.612 0l4.429 47.486L40.61 100z",
			fill: "#205B97"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.611 0h19.516v99.798H40.61V0z",
			fill: "#2E73B7"
		})
	]
});
export default SvgRedshift;
